import React, { useState } from "react";
import { API_URL_LOCALE_BASE } from "../../configuration/config";
import axios from "axios";
import Swal from 'sweetalert2'
import Loading from "../../Components/shared/Loading/Loading";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

const Carga = (props:any) =>{
    
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState('');
    const [tipoGrafico, setTipoGrafico] = useState('');
    const [filePicked, setFilePicked] = useState(false);

    const uploadFile = (fileParam:any) => {
        let file = fileParam[0];
        setFile(file);
        setFilePicked(true);
    }

    const HandleChange = (e:any) => {
        setFile(e.target.files[0]);
        setFilePicked(true);
    }

    const HandleSubmit = (event:any) => {
        event.preventDefault();
        setIsLoading(true)
        if(filePicked && parseInt(tipoGrafico) > 0){
            const typeData = {
                headers: {
                    "content-type": "multipart/form-data",
                    'Authorization' : "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTg5NTY3NzAsImlhdCI6MTY1ODk1NjcxMCwiaXNzIjoia2VuIiwiZGF0YSI6eyJpZCI6MSwibG9naW5fdGltZSI6MTY1ODk1NjcxMH19.45uOgB5kJN6b171vgpOxKILot0_QM9LdYVI119SNdRc"
                }
            };
            const formData = new FormData();
            formData.append('file_excel', file);
            formData.append('tipoGrafico', tipoGrafico);
            axios.post( API_URL_LOCALE_BASE + 'data-graph-tipo', formData, typeData).then( async (response:any) =>{
                let {data} = response;
                if(parseInt(data.status) === 200){
                    Toast.fire({
                        icon: 'success'
                        ,title: 'Archivo Excel Ingresado con Exito!'
                    });
                } else {
                    Toast.fire({
                        icon: "error"
                        ,title: "Error: Status " + data.status
                    });
                }
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
            Toast.fire({
                icon: "error"
                ,title: "Valide los Datos a Ingresar"
            });
        }
    }

    return(
        <>
            {isLoading ? <Loading loading={isLoading} /> : null}
            <div className="card m-2 mt-4">
                <div className="card-header">
                    <h1>Cargar Excel Grafico</h1>
                </div>
                <div className="card-body">
                    <form>
                        <select id="tipoGrafico" name="tipoGrafico" className="form-select" defaultValue="0" onChange={(e:any) => setTipoGrafico(e.target.value)}>
                            <option value="0">Seleccione un tipo de grafico</option>
                            {props.options.map((item:any) => {
                                return (
                                    <option value={item.value} key={item.value}>{item.label}</option>
                                )
                            })}
                        </select>
                        <div className="mb-3 mt-5">
                            <label className="form-label">Seleccione el arhcivo excel que desea cargar</label>
                            <input className="form-control" type="file" id="excel" name="excel" onChange={HandleChange}/>
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button type="submit" className="btn btn-primary" onClick={HandleSubmit}>Subir Excel</button>
                        </div>
                    </form>
                </div>
                <div className="card-footer">
                    
                </div>
            </div>
        </>
    )
}

export default Carga;